module.exports = __webpack_public_path__ + "img/p8_2.b67c26b2.png";